import * as d3 from 'd3'

import React, { useEffect, useRef } from 'react'

import ReactDOM from 'react-dom'

const PieCircleGraph = ({ data, ...props }) => {
  const height = 100
  const width = 100
  const radius = Math.min(width, height) / 2

  // componentDidUpdate() {
  //   this.drawPia()
  // }

  // componentDidMount() {
  //   this.drawPia()
  // }
  const svgRef = useRef()

  const drawPia = _ => {
    if (!svgRef.current) return

    const dataColor = data.map(b => ({
      ...b,
      color: 'rgb(' + b.red + ',' + b.green + ',' + b.blue + ')',
    }))

    const svg = d3.select(svgRef.current)
    svg.selectAll('*').remove()
    const g = svg
      .append('g')
      .attr('transform', 'translate(' + height / 2 + ',' + width / 2 + ')')

    const pie = d3
      .pie()
      .value(d => d.percent)
      .startAngle(0)

    const path = d3
      .arc()
      .innerRadius(0)
      .outerRadius(radius)
    const arc = g
      .selectAll('.arc')
      .data(pie(dataColor))
      .enter()
      .append('g')
      .attr('class', 'arc')

    arc
      .append('path')
      .attr('d', path)
      .attr('fill', d => d.data.color)
      .attr('item', d => d.data.item)
  }
  useEffect(drawPia, [data, radius])

  return (
    <div
      style={{
        ...props.style,
        display: 'grid',
        // justifyContent: 'center',
        alignContent: 'center',
        zIndex: 500,
      }}
    >
      <svg ref={svgRef} height={height} width={width} />
    </div>
  )
}
export default PieCircleGraph
